import styles from './PreviewEditMessage.module.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { useLockObject } from '../../../../hooks/object-lock-subscription/useLockObject';
import EraserIcon from '../../../../icons/EraserIcon';
import { HookedUserIcon } from '../../../user-icon/useUserIconRegister';

interface Props {
  entityId: string;
}

export const PreviewEditMessage: React.FC<Props> = ({ entityId }: Props) => {
  const { t } = useTranslation();

  const { isLocked } = useLockObject();

  const { locked, lockedBy } = isLocked(entityId);
  let message = [<EraserIcon />, <span>{t('MASK.EDIT_MESSAGE')}</span>];
  if (locked)
    message = [
      <HookedUserIcon userId={lockedBy?.id} locked={true} />,
      <div>
        {' '}
        <span className={styles['bold']}>{lockedBy?.displayName}</span>
        <span>{t('MASK.LOCKED_PREVIEW')}</span>
      </div>,
    ];
  return <div className={styles.root}>{message}</div>;
};
